import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { LegacyCityPropType, Question } from '@ratehub/base-ui';


function QuestionStandardCity({ city }) {
    return (
        <Question
            field={{
                name: 'city',
                type: 'city',
                value: city,
                required: true,
            }}
            labelMessage={(
                <FormattedMessage
                    id="InsLifeWizard.QuestionStandardCity.label"
                    defaultMessage="City of residence"
                />
            )}
            tooltipMessage={(
                <FormattedMessage
                    id="InsLifeWizard.QuestionStandardCity.tooltip"
                    defaultMessage="Different life insurance companies and products may be available based on the city you live in. Knowing which companies and products are available in your city is an important first step to helping you compare life insurance rates."
                />
            )}
        />
    );
}

QuestionStandardCity.propTypes = {
    city: LegacyCityPropType,
};

export default observer(QuestionStandardCity);
